/**
 * Выравнивание высоты карточек лауреатов
 * Блок Лауреаты проекта Совесть
 */

(function() {
	'use strict';

	/**
	 * Выравнивает высоту элементов .laureate-texts в каждом ряду
	 */
	function equalizeHeightsInRows() {
		const laureatesLists = document.querySelectorAll('.laureates-list');
		
		if (!laureatesLists.length) {
			return;
		}

		laureatesLists.forEach(function(list) {
			const items = Array.from(list.querySelectorAll('.laureate-item'));
			
			if (!items.length) {
				return;
			}

			// Сбрасываем высоту перед вычислением
			items.forEach(function(item) {
				const textsBlock = item.querySelector('.laureate-texts');
				if (textsBlock) {
					textsBlock.style.height = 'auto';
				}
			});

			// Получаем количество колонок из CSS grid
			const computedStyle = window.getComputedStyle(list);
			const gridTemplateColumns = computedStyle.gridTemplateColumns;
			
			// Вычисляем количество колонок
			let columnsCount = 3; // По умолчанию
			if (gridTemplateColumns && gridTemplateColumns !== 'none') {
				columnsCount = gridTemplateColumns.split(' ').length;
			}

			// Группируем элементы по рядам
			const rows = [];
			for (let i = 0; i < items.length; i += columnsCount) {
				rows.push(items.slice(i, i + columnsCount));
			}

			// Выравниваем высоту в каждом ряду
			rows.forEach(function(row) {
				let maxHeight = 0;
				
				// Находим максимальную высоту .laureate-texts в ряду
				row.forEach(function(item) {
					const textsBlock = item.querySelector('.laureate-texts');
					if (textsBlock) {
						const height = textsBlock.offsetHeight;
						if (height > maxHeight) {
							maxHeight = height;
						}
					}
				});

				// Устанавливаем максимальную высоту для всех .laureate-texts в ряду
				if (maxHeight > 0) {
					row.forEach(function(item) {
						const textsBlock = item.querySelector('.laureate-texts');
						if (textsBlock) {
							textsBlock.style.height = maxHeight + 'px';
						}
					});
				}
			});
		});
	}

	/**
	 * Инициализация
	 */
	function init() {
		// Выравниваем высоту после полной загрузки страницы
		equalizeHeightsInRows();

		// Переравниваем при изменении размера окна
		let resizeTimeout;
		window.addEventListener('resize', function() {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(function() {
				equalizeHeightsInRows();
			}, 250);
		});

		// Переравниваем после загрузки изображений
		const images = document.querySelectorAll('.laureate-photo');
		let loadedImages = 0;
		const totalImages = images.length;

		if (totalImages > 0) {
			images.forEach(function(img) {
				if (img.complete) {
					loadedImages++;
					if (loadedImages === totalImages) {
						equalizeHeightsInRows();
					}
				} else {
					img.addEventListener('load', function() {
						loadedImages++;
						if (loadedImages === totalImages) {
							equalizeHeightsInRows();
						}
					});
					img.addEventListener('error', function() {
						loadedImages++;
						if (loadedImages === totalImages) {
							equalizeHeightsInRows();
						}
					});
				}
			});
		}
	}

	// Запускаем инициализацию
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Экспортируем функцию для возможного переиспользования
	window.laureatesEqualizeHeights = equalizeHeightsInRows;

})();
